// Module
var code = `<table class="table" ng-if="vm.rows.length > 0" fixed-table-headers="scrollable-area" ng-table>
    <tr>
        <th>Дивизион</th>
        <th ng-repeat="k in vm.columns">{{ k }}</th>
    </tr>
    <tr ng-repeat="row in vm.rows">
        <td>{{ row.instance_type }}</td>
        <td
            ng-repeat="k in vm.columns"
            ng-style="{'background-color': get_bg_color(row[k], k)}"
            tooltip-append-to-body="true"
            uib-tooltip="{{ row.tooltips[k] }}"
        >
            {{ row[k] }}
        </td>
    </tr>
</table>
`;
// Exports
module.exports = code;